import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ss from "./Host.module.css";
import HostCard from "../../components/HostCard";
import CreateGame from "../../components/CreateGame";
import { apiRequest, showLoading, showAlert } from "../../utils";
import { Confirm } from "../../components/confirm/confirm";

export default function Home() {
  const storeUUID = new URLSearchParams(window.location.search).get("sid");
  const navigation = useNavigate();
  const [Create_popup, setCreate_popup] = useState(false); //创建游戏弹框
  const storeUuidRef = useRef("");
  const cardBoxRef = useRef(null);
  const shouldScrollToLeftRef = useRef(false);

  const open_create = () => {
    setCreate_popup(true);
  };
  const clone_create = () => {
    setCreate_popup(false);
  };

  //卡片数据
  const [card_data, setCard_data] = useState([]);

  // 创建场次后，列表刷新完再滚到最左侧，方便看到最新场次
  useEffect(() => {
    if (!shouldScrollToLeftRef.current || !cardBoxRef.current) return;
    cardBoxRef.current.scrollLeft = 0;
    shouldScrollToLeftRef.current = false;
  }, [card_data]);

  // 更新场次
  const update_card = (scrollToLeft = false) => {
    const loading = showLoading("加载中");
    apiRequest("/get_game_session_list", "GET", {
      store_uuid: storeUuidRef.current,
    })
      .then((res) => {
        if (res.code === 0) {
          if (scrollToLeft) shouldScrollToLeftRef.current = true;
          setCard_data(res.game_sessions);
          localStorage.setItem("store_uuid", storeUuidRef.current);
        } else showAlert(res.msg);
      })
      .catch((err) => showAlert("请求失败，请稍后重试", err.message))
      .finally(() => loading.hide());
  };

  // 跳转准备页面
  const go_ready = (session_uuid) => {
    const session = card_data.find((v) => v.uuid === session_uuid);
    if (session.status === 0) {
      // 游戏未开始前，进入该场次的设置昵称页面
      navigation("/prepare?session_uuid=" + session_uuid);
    } else if (session.status === 50) {
      navigation("/Await?session_uuid=" + session_uuid);
    } else if (session.status > 0) {
      // 游戏开始后，进入该场次的后台页面
      navigation("/Backstage?session_uuid=" + session_uuid);
    }
  };

  const hasPromptRef = useRef(false);
  useEffect(() => {
    if (hasPromptRef.current) return;
    hasPromptRef.current = true;
    let store_uuid = storeUUID ?? localStorage.getItem("store_uuid");
    if (!store_uuid) {
      store_uuid = window.prompt("请输入门店编号：");
    }
    if (store_uuid) {
      storeUuidRef.current = store_uuid;
      update_card();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={ss.bg}>
      <div className={ss.title}></div>
      <div className={ss.card_box} ref={cardBoxRef}>
        {card_data.map((data, index) => {
          return (
            <div key={data.uuid}>
              <HostCard
                total={card_data.length}
                index={index}
                data={data}
                go_ready={(v) => {
                  go_ready(v);
                }}
                clone={update_card}
              />
            </div>
          );
        })}

        <HostCard data={false} clone={open_create} />
      </div>
      <div
        style={{ display: "none" }} // 隐藏清理结束场次
        className={ss.clearSession}
        onClick={() => {
          Confirm.show("请确认是否清理结束场次", () => {
            const loading = showLoading("加载中");
            apiRequest("/clean_finished_sessions", "GET", {
              sid: storeUuidRef.current,
            })
              .then((res) => {
                if (res.code === 0) {
                  // showAlert("已清理结束场次");
                  update_card();
                } else showAlert(res.msg);
              })
              .catch((err) => showAlert("请求失败，请稍后重试", err.message))
              .finally(() => {
                loading.hide();
              });
          });
        }}
      >
        清理结束场次
      </div>
      {Create_popup && (
        <CreateGame
          clone={clone_create}
          new_card={() => {
            update_card(true);
          }}
        />
      )}
    </div>
  );
}
